import { render, staticRenderFns } from "./product-history-v2.modal.vue?vue&type=template&id=3b57ed6f&scoped=true"
import script from "./product-history-v2.modal.vue?vue&type=script&lang=js"
export * from "./product-history-v2.modal.vue?vue&type=script&lang=js"
import style0 from "./product-history-v2.modal.vue?vue&type=style&index=0&id=3b57ed6f&prod&lang=scss&scoped=true"
import style1 from "./product-history-v2.modal.vue?vue&type=style&index=1&id=3b57ed6f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57ed6f",
  null
  
)

export default component.exports